// Человекочитаемое сообщение об ошибке сохранения макета.
// Отдельный модуль (а не строки внутри контроллера) — чтобы покрыть тестами.

// 413 приходит от внешнего nginx (client_max_body_size), до Rails запрос не доходит:
// новые картинки уезжают в JSON целиком base64-строкой, и один файл на нескольких
// деталях дублируется по копии на деталь. Пока причина не устранена — объясняем её
// пользователю, чтобы он не бился в «Сохранить» вслепую.
export function saveErrorMessage(status, bytes = null) {
  if (status === 413) {
    const mb = bytes > 0 ? ` (${Math.round(bytes / 1024 / 1024)} МБ)` : ""
    return `макет слишком тяжёлый${mb}. Картинки вставляются в макет целиком, ` +
           `поэтому вес быстро растёт. Уменьшите разрешение картинок (или используйте их ` +
           `на меньшем числе деталей) и сохраните снова.`
  }
  if (status === 401 || status === 403) return "нет прав на сохранение или истекла сессия — обновите страницу и войдите заново."
  if (status >= 500) return `ошибка на сервере (${status}). Попробуйте ещё раз.`
  return `HTTP ${status}`
}
